import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

const TestimonialSlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.testimonials-slider__carousel');
        if (!carousels.length) return;

        carousels.forEach((carousel) => {
            const swiper = new Swiper(carousel, {
                slidesPerView: 'auto',
                spaceBetween: 40,
                loop: false,
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: true,
                    waitForTransition: true
                },
                slidesOffsetAfter: 0,
                modules: [Autoplay],
            });

            const prevButton = carousel.querySelector('.swiper-pagination__button-prev');
            const nextButton = carousel.querySelector('.swiper-pagination__button-next');

            if (!prevButton || !nextButton) {
                return;
            }

            const updateButtonStates = () => {
                prevButton.disabled = swiper.isBeginning;
                nextButton.disabled = swiper.isEnd;

                prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
            };

            prevButton.addEventListener('click', () => {
                swiper.slidePrev();
            });

            nextButton.addEventListener('click', () => {
                swiper.slideNext();
            });

            updateButtonStates();
            swiper.on('slideChange', updateButtonStates);
        });
    }

    return {
        init
    }
}

export default TestimonialSlider;
